import { ORGANIZATIONS_ENDPOINT } from "Constants";
import { baseApi as api } from "Services";
import {
  GetAiConfigRequest,
  GetAiConfigResponse,
  UpdateAiConfigRequest,
} from "../types";

const aiConfigurationUrl = (organizationId: string) =>
  `${ORGANIZATIONS_ENDPOINT}/organization/${organizationId}/ai-configuration`;

export const aiSettingsApi = api.injectEndpoints({
  endpoints: (build) => ({
    getAiConfig: build.query<GetAiConfigResponse, GetAiConfigRequest>({
      query: (queryArg) => ({
        url: aiConfigurationUrl(queryArg.organizationId),
      }),
    }),
    updateAiConfig: build.mutation<GetAiConfigResponse, UpdateAiConfigRequest>({
      query: (queryArg) => ({
        url: aiConfigurationUrl(queryArg.organizationId),
        method: "PUT",
        body: queryArg.body,
      }),
      async onQueryStarted(queryArg, { dispatch, queryFulfilled }) {
        const { data } = await queryFulfilled;
        // The form's values come from the getAiConfig cache; write the saved config back into it
        // so the form reflects the save immediately (and on re-navigation) without a refetch.
        dispatch(
          aiSettingsApi.util.updateQueryData(
            "getAiConfig",
            { organizationId: queryArg.organizationId },
            () => data,
          ),
        );
      },
      // Refresh whoami so AI feature gating elsewhere (e.g. the catalog "Generate" button)
      // reflects the change immediately.
      invalidatesTags: ["Whoami"],
    }),
  }),
});

export const { useGetAiConfigQuery, useUpdateAiConfigMutation } = aiSettingsApi;
